import React, { useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

/**
 * Hooks
 */
import useFlowMachine from "hooks/FlowMachine";
import { formatUrl } from "hooks/FlowMachine/utils";
import { stepTypes } from "hooks/FlowMachine/constants";

/**
 * Components
 */
import Step from "components/Step";
import ReviewStep from "components/ReviewStep";
import StepBody from "components/StepBody";

/**
 * Containers
 */
import StepForm from "containers/StepForm";
import StepHeader from "containers/StepHeader";

export default function Flow({ flow, onSubmit, handleRouteChange }) {
  const {
    steps,
    allowedRoutes,
    totalStepAmount,
    redirectUrl,
    isSubmitting,
    formReviewData,
    onStepSubmit,
    onStepChange,
    onFlowSubmit
  } = useFlowMachine({
    model: flow,
    onSubmit
  });
  function handleNavigateAway() {
    // we can not change this string, chrome, and firefox all force the use of their string for the leave message
    return "Are you sure you want to leave?";
  }
  useEffect(() => {
    window.addEventListener("onbeforeunload", handleNavigateAway);
    return () => {
      window.removeEventListener("onbeforeunload", handleNavigateAway);
    };
  }, []);
  const getStepByType = step => {
    switch (step.type) {
      case stepTypes.FORM:
        return (
          <StepForm
            onSubmit={e => onStepSubmit(e, step.id)}
            onChange={e => onStepChange(e, step.id)}
            description={step.description}
            schema={step.schema}
            disabled={isSubmitting}
            uiSchema={step.uiSchema}
            formData={step.formData}
          />
        );
      case stepTypes.REVIEW:
        return (
          <ReviewStep
            allStepsFormData={formReviewData}
            isSubmitting={isSubmitting}
            onSubmit={e => onFlowSubmit(e, step.id)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Switch>
        <Route
          path={allowedRoutes}
          render={() => {
            return (
              <>
                {steps.map((step, idx) => {
                  return (
                    <Step key={step.id} id={step.id}>
                      <StepHeader
                        id={step.id}
                        title={step.title}
                        isAllowed={step.isAllowed}
                        isActive={step.isActive}
                        isSubmitted={step.isSubmitted}
                        totalStepAmount={totalStepAmount}
                        idx={idx}
                      />
                      <Route
                        exact
                        path={formatUrl(step.id)}
                        render={() => (
                          <StepBody id={step.id} index={idx} title={step.title}>
                            {getStepByType(step)}
                          </StepBody>
                        )}
                      />
                    </Step>
                  );
                })}
              </>
            );
          }}
        />

        <Redirect to={redirectUrl} />
      </Switch>
    </div>
  );
}
